import { useEffect } from 'react';
import type { IUseVerifyFormCreatedProps } from '../types';

export const useVerifyFormCreated = ({
  isLoaded,
  isHydrated,
  formCreated,
  elementId,
  retryAttempt,
  createForm,
}: IUseVerifyFormCreatedProps) => {
  useEffect(() => {
    if (isLoaded && isHydrated && formCreated.current) {
      const verifyForm = setInterval(() => {
        const formElement = document.querySelector(`#${elementId} iframe`);
        if (!formElement && retryAttempt < 3) {
          formCreated.current = false;
          createForm();
        } else if (formElement) {
          clearInterval(verifyForm);
        }
      }, 1000);
      return () => clearInterval(verifyForm);
    }
  }, [isLoaded, isHydrated, retryAttempt, createForm, elementId, formCreated]);
}; 
